import { useQuery } from "react-query";
import { WorkspaceSettings } from "../models";
import { useCache } from "../context/CacheContext";
import { useWorkspace } from "../context/WorkspaceContext";
import { useUserSession } from "../context/UserContext";
import { queryKeys } from "../data/queryKeys";

/**
 * Workspace-level settings (default pickup location, hide pickup stops), read
 * from the Firestore `workspace_settings` collection. Returns `null` when the
 * workspace has no settings document yet.
 */
const useWorkspaceSettings = (workspaceId?: string) => {
  const { cacheKey } = useCache();
  const { activeWorkspace } = useWorkspace();
  const { userSession, isAuthenticated } = useUserSession();
  const resolvedWorkspaceId = workspaceId ?? activeWorkspace?.workspaceId ?? "";
  const token = userSession?.token?.accessToken;

  return useQuery<WorkspaceSettings | null, Error>(
    queryKeys.workspaceSettings(cacheKey, resolvedWorkspaceId),
    async () => WorkspaceSettings.getByWorkspaceId(resolvedWorkspaceId),
    {
      enabled: !!token && !!resolvedWorkspaceId && isAuthenticated(),
      keepPreviousData: true,
    },
  );
};

export default useWorkspaceSettings;
